{
  "containerLevel": [
    {
      "label": "containerId",
      "displayLabel": "Container Id",
      "editable": false,
      "hidden": true
    },
    {
      "label": "chargeId",
      "displayLabel": "Charge Id",
      "editable": false,
      "hidden": true
    },
    {
      "label": "chargeName",
      "displayLabel": "Charge Name",
      "placeholder": "Select Charge",
      "editable": false
    },
    {
      "label": "hsnOrSacCode",
      "displayLabel": "HSN Or SAC Code",
      "editable": false
    },
    {
      "label": "chargeCode",
      "displayLabel": "Charge Code",
      "editable": false
    },
    {
      "label": "description",
      "displayLabel": "Description",
      "placeholder": "Enter Description",
      "editable": false,
      "fieldInfo": {
        "disable": false,
        "dataType": "text",
        "style": {
          "width": "300px"
        }
      }
    },
    {
      "label": "type",
      "displayLabel": "Charge Type",
      "editable": false
    },
    {
      "label": "discount",
      "displayLabel": "Discount",
      "placeholder": "Enter Discount",
      "editable": true,
      "fieldInfo": {
        "disable": false,
        "dataType": "number"
      }
    },
    {
      "label": "amount",
      "displayLabel": "Charge Amount",
      "placeholder": "Enter Charge Amount",
      "editable": false,
      "fieldInfo": {
        "disable": false,
        "dataType": "text"
      }
    }
  ],
  "invoiceLevel": [
    {
      "label": "chargeId",
      "displayLabel": "Charge Id",
      "editable": false,
      "hidden": true
    },
    {
      "label": "chargeName",
      "displayLabel": "Charge Name",
      "placeholder": "Select Charge",
      "editable": false
    },
    {
      "label": "hsnOrSacCode",
      "displayLabel": "HSN Or SAC Code",
      "editable": false
    },
    {
      "label": "chargeCode",
      "displayLabel": "Charge Code",
      "editable": false
    },
    {
      "label": "description",
      "displayLabel": "Description",
      "placeholder": "Enter Description",
      "editable": false,
      "fieldInfo": {
        "disable": false,
        "dataType": "text"
      }
    },
    {
      "label": "discount",
      "displayLabel": "Discount",
      "placeholder": "Enter Discount",
      "editable": true,
      "fieldInfo": {
        "disable": false,
        "dataType": "number"
      }
    },
    {
      "label": "amount",
      "displayLabel": "Charge Amount",
      "placeholder": "Enter Charge Amount",
      "editable": false,
      "fieldInfo": {
        "disable": false,
        "dataType": "text"
      }
    }
  ]
}
